package com.gsb.vyapar.bhagya.presentation.auth.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.getOtp
import com.gsb.vyapar.bhagya.getPhoneNumber
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.auth.event.AuthUiEvents
import com.gsb.vyapar.bhagya.presentation.auth.util.connectToServer
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.EmailEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.MobileNumberEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.OtpEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.platformImePadding
import com.gsb.vyapar.bhagya.presentation.common.text.Text14Regular
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.message
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.util.LOGOIMG
import com.gsb.vyapar.bhagya.util.getPrivacyUrl
import com.gsb.vyapar.bhagya.util.getTermsUrl
import com.gsb.vyapar.bhagya.util.isValidOtp
import com.gsb.vyapar.bhagya.util.value

@Composable
fun LoginView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    var email by remember { mutableStateOf("") }
    var mobile by remember { mutableStateOf("") }
    var otp by remember { mutableStateOf("") }
    var isValidOtp by remember { mutableStateOf(false) }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar(if (uiState.authUiState.isEmail) "Verify Email" else "Login with OTP")
            Column(
                modifier = Modifier.verticalScroll(rememberScrollState()).fillMaxWidth().padding(16.dp).platformImePadding(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(Modifier.height(15.dp))
                CommonImage(splash, 200.dp, 200.dp)
                Spacer(Modifier.height(15.dp))
                if (uiState.authUiState.isEmail) {
                    EmailEditText(email) { email = it }
                } else {
                    MobileNumberEditText(mobile) { mobile = it }
                }
                if (uiState.authUiState.isOtpSent) {
                    Spacer(Modifier.height(8.dp))
                    OtpEditText(otp) {
                        otp = it
                        isValidOtp = isValidOtp(otp)
                    }
                    if (isValidOtp) {
                        Spacer(Modifier.height(16.dp))
                        GVBButton(text = "Verify OTP") { onTriggerEvent(UiEvents.AuthEvents(AuthUiEvents.VerifyOtp(otp))) }
                    }
                    if (uiState.authUiState.remainingTime <= 0) {
                        Spacer(Modifier.height(40.dp))
                        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                            Text14Regular("Did not receive an OTP?", message)
                            Spacer(Modifier.width(5.dp))
                            Text14RegularBB("Resend OTP", black, Modifier.clickable {
                                uiState.authUiState.resetAuthUiState()
                                onTriggerEvent(UiEvents.AuthEvents(if (uiState.authUiState.isEmail) AuthUiEvents.SendEmailOtp(email) else AuthUiEvents.SendMobileOtp(mobile)))
                            })
                        }
                        Spacer(Modifier.height(36.dp))
                    } else {
                        Spacer(Modifier.height(40.dp))
                        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                            Text14Regular("Resend OTP in ", message)
                            Spacer(Modifier.width(5.dp))
                            Text14RegularBB(uiState.authUiState.getRemainingTimeString(), black)
                        }
                        Spacer(Modifier.height(36.dp))
                    }
                } else {
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Send OTP") {
                        onTriggerEvent(UiEvents.AuthEvents(if (uiState.authUiState.isEmail) AuthUiEvents.SendEmailOtp(email) else AuthUiEvents.SendMobileOtp(mobile)))
                    }
                }
            }
            Spacer(Modifier.weight(1f))
            Row(modifier = Modifier.fillMaxWidth().padding(24.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                Text14RegularB("Privacy Policy", primary, Modifier.clickable { uriHandler.openUri(getPrivacyUrl()) })
                Text14RegularB("Terms & Conditions", primary, Modifier.clickable { uriHandler.openUri(getTermsUrl()) })
            }
        }
    }
    LaunchedEffect(Unit) {
        //connectToServer()
        launchDefault {
            if (!uiState.authUiState.isEmail) {
                mobile = getPhoneNumber().orEmpty()
            }
        }
        launchDefault {
            if (!uiState.authUiState.isEmail) {
                getOtp()?.let {
                    otp = it
                    isValidOtp = isValidOtp(otp)
                    if (isValidOtp) {
                        onTriggerEvent(UiEvents.AuthEvents(AuthUiEvents.VerifyOtp(otp)))
                    }
                }
            }
        }
    }
}